export function BadgeSuperRich({ superRich }: { superRich: boolean }) {
  if (!superRich) {
    return null
  }

  return (
    <span
      className="inline-flex h-4 shrink-0 items-center justify-center rounded-full px-1.5 text-[7px] font-bold uppercase tracking-[0.04em] text-white align-middle"
      style={{
        background:
          'linear-gradient(135deg, rgba(43, 45, 66, 0.96), rgba(215, 165, 74, 0.95))',
        border: '1px solid rgba(255, 230, 163, 0.24)',
        boxShadow: '0 2px 8px rgba(215, 165, 74, 0.24)',
        fontFamily: 'Nunito, sans-serif',
        lineHeight: 1,
      }}
    >
      <span style={{ position: 'relative', top: '1px' }}>Super Rich</span>
    </span>
  )
}
